export default "__VITE_ASSET__CvYegRJc__"